import { SvgIcon, SvgIconProps } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

export default function DeleteStopsIcon({
  color = RoutalPalette.error.medium,
  ...props
}: { color?: string } & Omit<SvgIconProps, `color`>) {
  return (
    <SvgIcon {...props} viewBox="0 0 15 14" style={{ width: `15px`, height: `15px`, ...props.style }}>
      <g fill="none">
        <path
          id="Vector"
          d="M11.4388 3.49984V11.6665C11.4388 11.9759 11.3159 12.2727 11.0971 12.4915C10.8783 12.7103 10.5816 12.8332 10.2722 12.8332H4.43882C4.1294 12.8332 3.83266 12.7103 3.61386 12.4915C3.39507 12.2727 3.27216 11.9759 3.27216 11.6665V3.49984M5.02216 3.49984V2.33317C5.02216 2.02375 5.14507 1.72701 5.36386 1.50821C5.58266 1.28942 5.8794 1.1665 6.18882 1.1665H8.52216C8.83157 1.1665 9.12832 1.28942 9.34711 1.50821C9.56591 1.72701 9.68882 2.02375 9.68882 2.33317V3.49984"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <g id="Vector_2">
          <path
            d="M11.4388 3.5V11.6667C11.4388 11.9761 11.3159 12.2728 11.0971 12.4916C10.8783 12.7104 10.5816 12.8333 10.2722 12.8333H4.43882C4.1294 12.8333 3.83266 12.7104 3.61386 12.4916C3.39507 12.2728 3.27216 11.9761 3.27216 11.6667V3.5"
            fill={color}
          />
          <path
            d="M11.4388 3.5V11.6667C11.4388 11.9761 11.3159 12.2728 11.0971 12.4916C10.8783 12.7104 10.5816 12.8333 10.2722 12.8333H4.43882C4.1294 12.8333 3.83266 12.7104 3.61386 12.4916C3.39507 12.2728 3.27216 11.9761 3.27216 11.6667V3.5"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <path
          id="Vector_3"
          d="M2.10547 3.5H3.27214H12.6055"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path id="Vector_4" d="M6.18878 6.4165V9.9165" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
        <path id="Vector_5" d="M8.52216 6.4165V9.9165" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
      </g>
    </SvgIcon>
  );
}
